// Header
export const DOCUMENT_ID = "documentId";
export const DOCUMENT_TYPE = "documentType";
export const BILLING_MONTH_YEAR = "billingMonthYear";
export const BILLING_MONTH = "billingMonth";
export const BILLING_YEAR = "billingYear";
export const COMMENT = "documentHeaderText";
export const CASH_APP_FILE = "cashAppFile";
export const CASH_APP_ID = "cashAppId";
export const ATTACHMENT_FILE = "attachmentFile";
export const POSTING_DATE = "postingDate";
export const YEAR = "postingYear";
export const POSTING_MONTH = "postingPeriod";

// line items
export const LINE_ITEMS = "lineItems";
export const DATE = "paymentDate"; // missing
export const LINE_ITEM_TEXT = "lineItemText";
export const CHEQUE_NO = "checkNumber";
export const AMOUNT = "amount";
export const CURRENCY = "currency";
export const BANK_INFO = "bankInfo";
export const BANK_CONF = "bankConf";
export const DRCR = "drCr";
export const GL_ACCOUNT = "glMasterId"; // missing
export const SUB_LEDGER = "subledger"; // missing
export const COMBINE = "combine";
export const COMBINE_PROP = "combineProp";
export const CUSTOMER_ACC = "propertyOwnershipId"; // missing
export const PAYMENT_METHOD = "paymentMethod";
export const OFFSET_ACC = "offsetAccount";
export const CLEARING = "cleared";
export const OL_DATE = "oiDate";
export const OL_REF = "oiReference";
export const OL_DOC_LI = "oiDocLi";
export const OL_TOTAL = "oiTotal";
export const LINE_ITEM_TYPE = "lineItemType";

export const VENDOR_ACC = "vendor";

export const drcrOptions = [
  { label: "Dr", value: "DR" },
  { label: "Cr", value: "CR" },
];
